import {
  CanvaModal,
  DragAndDrop,
  FlickrModal,
  GiphyModal,
  MediaAttached,
  MediaAttacherDropdown,
  PexelsModal,
  RecentlyUsedModal,
  URLModal,
  YoutubeModal,
} from './components';
import { useComposeBoxContext } from './composeBoxContext';

export const MediaSystemComponents = () => {
  const {
    isCanvaModalOpen,
    isComposeBoxOpen,
    isFlickrModalOpen,
    isGiphyModalOpen,
    isMediaAttacherOpen,
    isPexelsModalOpen,
    isRecentlyUsedModalOpen,
    isURLModalOpen,
    isYoutubeModalOpen,
  } = useComposeBoxContext();

  return (
    <>
      <MediaAttached />
      {isCanvaModalOpen && <CanvaModal />}
      {isFlickrModalOpen && <FlickrModal />}
      {isGiphyModalOpen && <GiphyModal />}
      {isPexelsModalOpen && <PexelsModal />}
      {isRecentlyUsedModalOpen && <RecentlyUsedModal />}
      {isURLModalOpen && <URLModal />}
      {isYoutubeModalOpen && <YoutubeModal />}
      {isMediaAttacherOpen && <MediaAttacherDropdown />}
      {isComposeBoxOpen && <DragAndDrop />}
    </>
  );
};
